// extracted by mini-css-extract-plugin
export default {"page":"results_page__xSv8U"};